export const chapterImageSize = {
  width: 150,
  height: 100,
} as const;
